import Widget               from "lib/widget";
import AjaxFileForm         from "servos/ajaxFileForm";
import { initBootstrapComponents } from "lib/bootstrapTooltips";

class DocumentUploadWidget extends Widget {
  bind() {
    this.modalContainer = this.root.find('#checklist-modal-container');
    this.checklistsRoot = this.root.find('#checklists-main-tab');
    bindDocumentUploadModal.call(this)
    bindEditDocumentModal.call(this)
    bindViewDocumentModal.call(this)
    bindCheckbox.call(this)
    bindDropDown.call(this)
  }
}

let bindDocumentUploadModal = function() {
  this.checklistsRoot.on('click', '.upload-document', (e) => {
    let documentUrl = getOrBuildUrl.call(this, e)
    $.ajax({
      url: documentUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      bindAjaxForm.call(this)
      this.emit('form-loaded')
    })
  })
}

let bindEditDocumentModal = function() {
  this.checklistsRoot.on('click', '.edit-document', (e) => {
    let documentUrl = getOrBuildUrl.call(this, e)
    $.ajax({
      url: documentUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      bindAjaxForm.call(this)
      bindDefaultCheckboxValue.call(this)
      bindDefaultDropDownValues.call(this)
      this.emit('form-loaded')
    })
  })
}

let bindViewDocumentModal = function() {
  this.checklistsRoot.on('click', '.view-document', (e) => {
    let documentUrl = getOrBuildUrl.call(this, e)
    $.ajax({
      url: documentUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
    })
  })
}

let bindCheckbox = function() {
  this.root.on('click', 'input[name="document[included_in_annexure]"]', (e) => {
    let container = $(e.currentTarget).parents('.item-document-container')
    let fieldContainer = container.find('.annexure-fields')
    let fields = fieldContainer.find('input, select')

    if (e.currentTarget.checked) {
      fieldContainer.removeClass('d-none')
      fields.attr('disabled', false)
    } else {
      fieldContainer.addClass('d-none')
      fields.attr('disabled', true)
    }
  })
}

let bindDefaultCheckboxValue = function() {
  let container = $('input[name="document[included_in_annexure]"]').parents('.item-document-container')
  let fieldContainer = container.find('.annexure-fields')
  let fields = fieldContainer.find('input, select')

  if ($('input[name="document[included_in_annexure]"]')[1].checked) {
    fieldContainer.removeClass('d-none')
    fields.attr('disabled', false)
  }
}

let bindDropDown = function() {
  this.root.on('change', '#document_stamp', (e) => {
    let container = $(e.currentTarget).parents('.item-document-container')

    let stampFieldContainer = container.find('.stamp-fields')
    let stampFields = stampFieldContainer.find('input, select')

    let receivedAtFieldContainer = container.find('.received-at-fields')
    let receivedAtFields = receivedAtFieldContainer.find('input, select')

    if (['certificate', 'details_noted'].includes(e.currentTarget.value)) {
      stampFieldContainer.removeClass('d-none')
      stampFields.attr('disabled', false)
    } else {
      stampFieldContainer.addClass('d-none')
      stampFields.attr('disabled', true)
    }

    if (e.currentTarget.value === 'received') {
      receivedAtFieldContainer.removeClass('d-none')
      receivedAtFields.attr('disabled', false)
    } else {
      receivedAtFieldContainer.addClass('d-none')
      receivedAtFields.attr('disabled', true)
    }
  })
}

let bindDefaultDropDownValues = function() {
  let container = $('select[name="document[stamp]"]').parents('.item-document-container')

  let stampFieldContainer = container.find('.stamp-fields')
  let stampFields = stampFieldContainer.find('input, select')

  let receivedAtFieldContainer = container.find('.received-at-fields')
  let receivedAtFields = receivedAtFieldContainer.find('input, select')

  if (['certificate', 'details_noted'].includes($('#document_stamp').val())) {
    stampFieldContainer.removeClass('d-none')
    stampFields.attr('disabled', false)
  }
  if ($('#document_stamp').val() === 'received') {
    receivedAtFieldContainer.removeClass('d-none')
    receivedAtFields.attr('disabled', false)
  }
}

let bindAjaxForm = function() {
  this.ajaxForm = new AjaxFileForm(this.formElem)
  this.ajaxForm.on('success', success.bind(this))
  this.ajaxForm.on("error",   errorResponse.bind(this))
};

let success = function(response) {
  updateItemRow.call(this, response)
  this.modalContainer.find('.modal').modal('hide');
  this.emit('item-updated')
}

// update item row
let updateItemRow = function(response) {
  let itemRow = this.checklistsRoot.find(`.checklist-item[data-item-id=${response.data.item.id}]`)
  itemRow.replaceWith(response.data.item.html);
  initBootstrapComponents(this.checklistsRoot);
  this.root.find('#general-badge').html(response.data.project.outstanding_general_badge)
  this.root.find('#project-checklist-labels').html(response.data.project.checklist_labels)
}

// this widget is shared with the external pages.
// For external pages we don't pass the url but the item id instead.
let getOrBuildUrl = function(e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/document_modal`
  }
}

let errorResponse = function(response) {
  this.formElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  this.formElem = this.modalContainer.find('form');
  bindAjaxForm.call(this);
  this.emit('form-loaded');
}

export default DocumentUploadWidget
